export enum PopupMessageType {
  Okay,
  YesNoQuestion,
  YesNoLabelQuestion,
  DeleteQuestion,
  OkayDeleteQuestion,
  OkayGrantQuestion,
  VsMsQuestion,
  CashQuestion,
  GroupCashQuestion,
  Select,
  DatePicker,
  TotpSetup,
  AssignKeytag
}
export class PopupMessage {
  public actions: Function[];
  public qrContent: string | null = null;

  constructor(
    public label: string,
    public type: PopupMessageType,
    public large: boolean,
    ...actions: Function[]
  ) {
    this.actions = actions;
  }
}
